import Cabine from "../assets/plans/cabine.svg";
import TractorLeft from "../assets/plans/tractorLeft.svg";
import TractorRight from "../assets/plans/tractorRight.svg";
import TractorFront from "../assets/plans/tractorFront.svg";
import TractorBack from "../assets/plans/tractorBack.svg";
import CarrierLeft from "../assets/plans/carrierLeft.svg";
import CarrierRight from "../assets/plans/carrierRight.svg";
import TrailerBack from "../assets/plans/trailerBack.svg";
import TrailerFront from "../assets/plans/trailerFront.svg";
import TrailerLeft from "../assets/plans/trailerLeft.svg";
import TrailerRight from "../assets/plans/trailerRight.svg";
import Document from "../assets/plans/document.svg";
import TrailerInside from "../assets/plans/trailerInside.svg";

export const tractorMapping: { [index: string]: { label: string } } = {
  roofRight: { label: "Toit" },
  underRoofRight: { label: "Sous toit" },
  doorRight: { label: "Portière" },
  rearCabinRight: { label: "Arrière de la cabine" },
  stepRight: { label: "Marche pied" },
  mirrorRight: { label: "Rétroviseur" },
  bodyRight: { label: "Châssis" },
  bumperRight: { label: "Pare-choc" },
  frontRimRight: { label: "Jante avant" },
  frontTireRight: { label: "Pneu avant" },
  backRimRight: { label: "Jante arrière" },
  backTireRight: { label: "Pneu arrière" },
  frontMudguardRight: { label: "Garde boue avant" },
  backMudguardRight: { label: "Garde boue arrière" },
  windowRight: { label: "Vitre" },
  roofLeft: { label: "Toit" },
  underRoofLeft: { label: "Sous toit" },
  doorLeft: { label: "Portière" },
  rearCabinLeft: { label: "Arrière de la cabine" },
  stepLeft: { label: "Marche pied" },
  mirrorLeft: { label: "Rétroviseur" },
  bodyLeft: { label: "Châssis" },
  bumperLeft: { label: "Pare-choc" },
  frontRimLeft: { label: "Jante avant" },
  frontTireLeft: { label: "Pneu avant" },
  backRimLeft: { label: "Jante arrière" },
  backTireLeft: { label: "Pneu arrière" },
  midRimLeft: { label: "Jante milieu" },
  midTireLeft: { label: "Pneu milieu" },
  midRimRight: { label: "Jante milieu" },
  midTireRight: { label: "Pneu milieu" },
  frontMudguardLeft: { label: "Garde boue avant" },
  backMudguardLeft: { label: "Garde boue arrière" },
  mudguardLeft: { label: "Garde boue gauche" },
  mudguardRight: { label: "Garde boue droit" },
  windowLeft: { label: "Vitre" },
  windshieldFrame: { label: "Cadre pare-brise" },
  apron: { label: "Tablier" },
  bumper: { label: "Pare-choc" },
  headlightLeftBot: { label: "Phare gauche bas" },
  headlightLeftMid: { label: "Phare gauche milieu" },
  headlightLeftTop: { label: "Phare gauche haut" },
  headlightRightBot: { label: "Phare droit bas" },
  headlightRightMid: { label: "Phare droit milieu" },
  headlightRightTop: { label: "Phare droit haut" },
  underRoofFront: { label: "Sous toit" },
  roofFront: { label: "Toit" },
  mirrorFrontLeft: { label: "Rétroviseur gauche" },
  mirrorFrontRight: { label: "Rétroviseur droit" },
  windshield: { label: "Pare-brise" },
  headlightBackRight: { label: "Phare arrière droit" },
  headlightBackLeft: { label: "Phare arrière gauche" },
  mirrorBackLeft: { label: "Rétroviseur Gauche" },
  mirrorBackRight: { label: "Rétroviseur Droit" },
  bodyBack: { label: "Carrosserie arrière" },
  trailerLeft: { label: "Remorque gauche" },
  trailerRight: { label: "Remorque droite" },
  trailerRightDoor: { label: "Porte droite" },
  trailerLeftDoor: { label: "Porte gauche" },
  trailerBodyFront: { label: "Avant Trailer" },
  bumperBack: { label: "Pare-choc arrière" },
};

export const svgMapping = (side: string, type: string) => {
  let currentSvg = "";
  if (side === "Document") {
    currentSvg = Document;
  } else if (side === "Front") {
    if (type === "Tractor" || type === "Carrier") {
      currentSvg = TractorFront;
    } else if (type === "Trailer") {
      currentSvg = TrailerFront;
    }
  } else if (side === "Right") {
    if (type === "Tractor") {
      currentSvg = TractorRight;
    } else if (type === "Carrier") {
      currentSvg = CarrierRight;
    } else if (type === "Trailer") {
      currentSvg = TrailerRight;
    }
  } else if (side === "Left") {
    if (type === "Tractor") {
      currentSvg = TractorLeft;
    } else if (type === "Carrier") {
      currentSvg = CarrierLeft;
    } else if (type === "Trailer") {
      currentSvg = TrailerLeft;
    }
  } else if (side === "Back") {
    if (type === "Tractor") {
      currentSvg = TractorBack;
    } else if (type === "Carrier" || type === "Trailer") {
      currentSvg = TrailerBack;
    }
  } else if (side === "Inside") {
    currentSvg = Cabine;
  } else if (side === "TrailerInside") {
    currentSvg = TrailerInside;
  }

  return currentSvg;
};
